/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_MonthlyInputs */

const zh_pricing_monthly = /** @type {(inputs: Pricing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月付`)
};

const en_pricing_monthly = /** @type {(inputs: Pricing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const es_pricing_monthly = /** @type {(inputs: Pricing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Pricing_MonthlyInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_monthly = /** @type {((inputs?: Pricing_MonthlyInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_MonthlyInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_monthly(inputs)
	if (locale === "en") return en_pricing_monthly(inputs)
	return es_pricing_monthly(inputs)
});